/** The grip bar a floating pop-up is dragged by (see utils/useDragOffset). Double-click puts the pop-up back. */
import type { useDragOffset } from '@/utils/useDragOffset';

export function DragBar({ drag, rounded = true }: { drag: ReturnType<typeof useDragOffset>; rounded?: boolean }) {
  const { handleProps, dragging } = drag;
  return (
    <div
      {...handleProps}
      data-testid="popover-drag-handle"
      title="Drag to move · double-click to put it back"
      style={{
        ...handleProps.style, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
        height: 18, background: dragging ? '#e2e8f0' : '#f1f5f9', borderBottom: '1px solid #e2e8f0',
        color: '#64748b', fontSize: 10, fontWeight: 600, letterSpacing: '0.04em',
        borderRadius: rounded ? '8px 8px 0 0' : undefined,
      }}
    >
      <span aria-hidden style={{ fontSize: 12, lineHeight: 1, letterSpacing: '-1px' }}>⠿⠿</span>
      DRAG TO MOVE
    </div>
  );
}
